export default {
  isCardDesktop: false,
};
